export class ProductoId {
    codigoProducto: number;
    codigoMarca: number;
}